import { render, staticRenderFns } from "./identity-means-transport.vue?vue&type=template&id=7ed2cd3d&lang=html&"
import script from "./identity-means-transport.vue?vue&type=script&lang=js&"
export * from "./identity-means-transport.vue?vue&type=script&lang=js&"
import style0 from "./identity-means-transport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCardTitle,VDataTable,VDivider,VFlex,VSpacer,VTextField,VToolbar,VToolbarTitle})
